import {Overlay} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/Overlay';
import {Page} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/Page';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {
    PageOverlayTabsContextMenuIcon,
    PageOverlayTabsContextMenuIcons
} from '@mintdata-wsp/wsp/ui/views/visualDesigner/surface/area/contextMenu/pageOverlaysTabs/PageOverlayTabsContextMenuIcon';
import {ContextMenuTarget, IContextMenuItem} from '@mintdata/mint-kit/impl/components/contextMenu/ContextMenu';
import * as React from 'react';

export abstract class PageOverlayTabsContextMenuProvider
{
    public static contextMenuProvider(overlay:Overlay):(target:ContextMenuTarget) => IContextMenuItem[]
    {
        return function contextMenuProviderForPage(target:ContextMenuTarget):IContextMenuItem[]
        {
            const {surfaceArea} = controllers.ui;
            const activePage:Page = surfaceArea.getActivePage();
            const overlayIndex:number = activePage.overlays.findIndex((target:Overlay) => target === overlay);

            if( !(target instanceof HTMLElement) )
            {
                return [];
            }

            const movePart:IContextMenuItem[] = activePage.overlays.length > 1
                ? [
                    {
                        label: 'Move Upward',
                        handler: () => surfaceArea.moveOverlay(overlay, overlayIndex + 1),
                        isDisabled: overlayIndex === activePage.overlays.length - 1,
                        icon: <PageOverlayTabsContextMenuIcon icon={PageOverlayTabsContextMenuIcons.EMPTY}/>
                    },
                    {
                        label: 'Move Downward',
                        handler: () => surfaceArea.moveOverlay(overlay, overlayIndex - 1),
                        isDisabled: overlayIndex === 0,
                        icon: <PageOverlayTabsContextMenuIcon icon={PageOverlayTabsContextMenuIcons.EMPTY}/>
                    },
                    {
                        isSeparator: true,
                    },
                ]
                : [];

            return [
                {
                    label: `${overlay.isHidden ? 'Show' : 'Hide'} Overlay`,
                    handler: () => {
                        if( overlay.isHidden )
                            surfaceArea.makeOverlayVisible(overlay);
                        else
                            surfaceArea.makeOverlayHidden(overlay);
                    },
                    icon: <PageOverlayTabsContextMenuIcon
                        icon={overlay.isHidden ? PageOverlayTabsContextMenuIcons.SHOW : PageOverlayTabsContextMenuIcons.HIDE}
                    />
                },
                {
                    label: 'Always present on page',
                    handler: () => surfaceArea.togglePinOverlay(overlay),
                    icon: <PageOverlayTabsContextMenuIcon
                        icon={overlay.isPinned ? PageOverlayTabsContextMenuIcons.PIN : PageOverlayTabsContextMenuIcons.UNPIN}
                    />
                },
                {
                    isSeparator: true,
                },
                {
                    label: 'Remove Overlay',
                    handler: () => surfaceArea.removeOverlay(overlay),
                    icon: <PageOverlayTabsContextMenuIcon icon={PageOverlayTabsContextMenuIcons.REMOVE}/>
                },
                {
                    isSeparator: true,
                },
                ...movePart,
                {
                    label: <span>Go to <b>{overlay.page.name}</b> Page</span>,
                    handler: () => {surfaceArea.setActivePage(overlay.page)},
                    icon: <PageOverlayTabsContextMenuIcon icon={PageOverlayTabsContextMenuIcons.EMPTY}/>
                }
            ];
        }
    }
}
